import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import {
  TransferOutAmountWithSwap,
  TransferOutAvailableWalletAmount,
  TransferOutNumberPad,
  TransferOutButtonConfirmation,
  // TransferOutHeader,
  // TransferOutSettingsAndFees,
  ResetTransferOutOnRouteEntry,
} from '@/features/savings'
import { useUserStore } from '@/store/useUserStore'
import useOffsets from '@/hooks/useOffsets'
import { StickyHeaderNavigation } from '@/components'

export default function TransferOutScreen() {
  const { t } = useTranslation()
  const offsets = useOffsets()

  // Get wallet data
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Show error if no available currencies
  if (!completeCurrencies?.length) {
    return (
      <BaseView
        flex={1}
        center
        bgColor="background.screen"
        style={{
          height: '100vh',
          paddingTop: offsets.top + 70,
        }}
      >
        <BaseText fontSize={16} color="label.secondary" textAlign="center">
          {'No currencies available'}
        </BaseText>
      </BaseView>
    )
  }

  return (
    <>
      <ResetTransferOutOnRouteEntry />

      <BaseView
        flex={1}
        bgColor="background.screen"
        style={{
          height: '100vh',
          paddingTop: offsets.top + 70,
        }}
      >
        {/* Header */}
        {/* <TransferOutHeader /> */}
        <StickyHeaderNavigation title={t('form:actions.transferOut')} />

        <BaseView flex={1} px={12} className="flex flex-col h-full">
          {/* Central area with amount display */}
          <BaseView
            align="center"
            gap={14}
            className="flex-1 flex flex-col justify-start"
            style={
              {
                // paddingTop: 28,
              }
            }
          >
            <BaseView gap={16} center>
              <TransferOutAmountWithSwap />
              <TransferOutAvailableWalletAmount />
            </BaseView>

            {/* Settings and Fees */}
            {/* <TransferOutSettingsAndFees /> */}
          </BaseView>

          {/* Bottom area with keyboard and button */}
          <BaseView
            className="mt-auto"
            gap={12}
            style={{ paddingBottom: offsets.bottom }}
          >
            <TransferOutNumberPad />
            <TransferOutButtonConfirmation />
          </BaseView>
        </BaseView>
      </BaseView>
    </>
  )
}
